import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from "react-bootstrap";
import { lighten, makeStyles } from "@material-ui/core/styles";
import SolutionArticleSummaryCard from "./SolutionArticleSummaryCard";
import "./SolutionArticleSummary.scss";

export default function SolutionArticleSummary(props) {

  const {title, items } = props.data;

  const useStyles = makeStyles(theme => ({
    backgroundColor: {
      backgroundColor: lighten(theme.palette.primary.main, 0.92),
    }
  }));

  const classes = useStyles();

  return (
    <Row className={`article-summary-container ${classes.backgroundColor}`}>
      <Col>
        <Row className="section-title">
          <h2>{title}</h2>
        </Row>
        <Row className="section-content-container">
          <div className="section-content">
            {items.map((item, index) => <SolutionArticleSummaryCard key={index} data={item} scrollToElement={props.scrollToElement}/>)}
          </div>
        </Row>
      </Col>
    </Row>
  )
}

SolutionArticleSummary.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.array,
  }),
  scrollToElement: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/SolutionsArticleSummary/SolutionArticleSummary.js